import './styles.scss';

import 'material-symbols';
import * as bootstrap from 'bootstrap'

import OmMap from './om-map/om-map.ts';
import VisTimeLine from './vis-time-line/vis-time-line.ts';
import TimeLineJS from './time-line-js/time-line-js.ts';

// LexicalEditor and plugins
import LexicalEditor from "./blazor-lexical-editor/lexical-editor.ts";

import { collapseMenu } from "./utils";

declare global {
    interface Window {
        bootstrap: typeof bootstrap;
        OmMap: typeof import("./om-map/om-map").default;
        VisTimeLine: typeof import("./vis-time-line/vis-time-line").default;
        TimeLineJS: typeof import("./time-line-js/time-line-js").default;
        ShowMsg: (msg: string) => void;

        LexicalEditor: typeof import("./blazor-lexical-editor/lexical-editor").default;
    }
}

class ApplicationInitializer {
    private static readonly QUILL_THEME = 'snow';

    constructor() {
        this.initializeBootstrap();
        this.registerComponents();
    }

    private initializeBootstrap(): void {
        window.bootstrap = bootstrap;
    }

    private registerComponents(): void {
        window.OmMap = OmMap;
        window.VisTimeLine = VisTimeLine;
        window.TimeLineJS = TimeLineJS;
        window.ShowMsg = (msg: string) => console.log(msg);

        window.LexicalEditor = LexicalEditor;
    }
}

// Initialize the application
new ApplicationInitializer();
